import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import SellerQuotePublishedSuccessfullyContainer from '../containers/SellerQuotePublishedSuccessfully/SellerQuotePublishedSuccessfully.container'

/**
 * The SellerQuotePublishedSuccessfully's page.
 */
const SellerQuotePublishedSuccessfully = () => {
  return (
    <AuthorizationProviderContainer>
      <ProtectByAccessToken>
        <BrandLayout>
          <SellerQuotePublishedSuccessfullyContainer />
          <OnboardingDialogContainer />
        </BrandLayout>
      </ProtectByAccessToken>
    </AuthorizationProviderContainer>
  )
}

export default SellerQuotePublishedSuccessfully
